module.exports = __webpack_public_path__ + "static/img/baoming2.c5ba891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/baoming2.png
// module id = kLz6
// module chunks = 0